<template>
  <component :is="itemData === undefined ? 'div' : 'b-card'">

    <!-- Alert: No item found -->
    <b-alert
      variant="danger"
      :show="itemData === undefined"
    >
      <h4 class="alert-heading">
        Error fetching user data
      </h4>
      <div class="alert-body">
        No user found with this user id. Check
        <b-link
          class="alert-link"
          :to="{ name: 'app-adm-produtos'}"
        >
          User List
        </b-link>
        for other users.
      </div>
    </b-alert>

    <user-edit-tab-account
      :value="itemData"
      class="pt-0"
      @handleSubmit="handleSubmit"
    />

  </component>
</template>

<script>
import {
  BTab, BTabs, BCard, BAlert, BLink,
} from 'bootstrap-vue'
import { ref, onUnmounted, onMounted } from '@vue/composition-api'
import router from '@/router'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import userStoreModule from '../ProdutosStoreModule'
import UserEditTabAccount from './FormEditAdd.vue'
import FormImagens from './FormImagens.vue'

export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,
    FormImagens,
    UserEditTabAccount,
  },
  setup() {
    const toast = useToast()
    const userData = ref(JSON.parse(localStorage.getItem('userData')))
    const itemData = ref({
      id: null,
      uuid: null,
      id_categoria: null,
      item_nome: '',
      item_code: null,
      ativo: 1,
      item_descricao: '',
      id_tabela_preco: null,
      tipo_produto: 'normal',
      quantidade: 1,
      comissao: 25,
      comprimento: 0,
      largura: 0,
      altura: 0,
      peso: 0,
      valor_frete: 0,
      embalagem: 0,
      preco_venda: '',
      imagens: [],
      subprodutos: [],
    })

    const resetClienteData = () => {
      itemData.value = {
        id: null,
        uuid: null,
        id_categoria: null,
        item_nome: '',
        item_code: null,
        ativo: 1,
        item_descricao: '',
        id_tabela_preco: null,
        tipo_produto: 'normal',
        quantidade: 1,
        comissao: 25,
        comprimento: 0,
        largura: 0,
        altura: 0,
        peso: 0,
        valor_frete: 0,
        embalagem: 0,
        preco_venda: '',
        imagens: [],
        subprodutos: [],
      }
    }

    const substituirCaracteresEspeciais = string => {
      const regex = /[^\w]/g
      const novaString = string.replace(regex, '_')
      return novaString
    }

    const updateCreateImageItem = item => {
      const imageUrl = []
      if (imagensProvisorias.value.length > 0) {
        imagensProvisorias.value.forEach(async img => {
          const { file } = img
          if (file === undefined) return
          const formtData = new FormData()
          formtData.append('image', file)
          formtData.set('caminho', `${userData.value.uuid}_${userData.value.id}/item_imagens/items_${item.uuid}_${substituirCaracteresEspeciais(item.item_nome)}`)
          await store.dispatch('appAdmProdutos/uploadImages', { formData: formtData })
            .then(async resp => {
              imageUrl.push(resp.data.image_url)
              await store.dispatch('appAdmProdutos/createImageItem', {
                id_item_produto: item.id,
                caminho_imagem: resp.data.image_url,
              })
            })
        })
      }
    }

    const updateCreateVariasImagensUnitarias = async item => {
      const caminho = `${userData.value.uuid}_${userData.value.id}/item_imagens/items_${item.id}_${item.item_nome.replace(/[^\w]/g, '_')}`
      const imagensForm = await Promise.all(
        item.imagens
          .filter(f => f !== undefined)
          .map(async file => {
            const formData = new FormData()
            formData.append('image', file)
            formData.append('caminho', caminho)

            const response = await store.dispatch('appAdmProdutos/uploadImages', { formData })

            return {
              id_item_produto: item.id,
              ativo: true,
              caminho_imagem: response.data.image_url,
            }
          }),
      )

      if (imagensForm.length === 0) {
        return
      }

      await store.dispatch('appAdmProdutos/createVariasImageItem', { imagens: imagensForm })
        .then(resp => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Sucesso',
              text: resp.data.message,
              icon: 'AlertTriangleIcon',
              variant: 'success',
            },
          })
        })
    }
    const handleSubmit = async () => {
      const isProcessingImages = store.getters['appAdmProdutos/GET_IS_PROCESSING_IMAGES']

      if (isProcessingImages) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Aguarde',
            text: 'As imagens ainda estão sendo compactadas. Tente salvar novamente em alguns segundos.',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        })
        return
      }

      const allImages = store.getters['appAdmProdutos/GET_IMAGENS_ITEM'] || []
      const existingImages = allImages.filter(img => img.caminho_imagem)
      const newImages = allImages.filter(img => img.file && !img.caminho_imagem)

      if (existingImages.length === 0 && newImages.length === 0) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Algo deu errado',
            text: 'É necessário adicionar pelo menos uma imagem',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
        return
      }

      itemData.value.imagens = newImages.map(img => img.file)

      if (itemData.value.id !== null) {
        await store.dispatch('appAdmProdutos/update', itemData.value)
          .then(async resp => {
            itemData.value.id = resp.data.id
            if (newImages.length > 0) {
              await updateCreateVariasImagensUnitarias(itemData.value)
            }
            await router.push({ name: 'app-adm-produtos' })
          })
        return
      }
      await store.dispatch('appAdmProdutos/save', itemData.value)
        .then(async resp => {
          itemData.value.id = resp.data.id
          await updateCreateVariasImagensUnitarias(itemData.value)
          await router.push({ name: 'app-adm-produtos' })
        })
    }

    onMounted(() => {
      if (typeof router.currentRoute.params.id !== 'undefined') {
        store.dispatch('appAdmProdutos/findById', { id: router.currentRoute.params.id })
          .then(response => {
            const item = response.data
            itemData.value = {
              id: item.id,
              uuid: item.uuid,
              tipo_produto: item.tipo_produto,
              subprodutos: item.subprodutos,
              item_code: item.item_code,
              item_nome: item.item_nome,
              quantidade: item.quantidade,
              comissao: item.comissao,
              comprimento: item.comprimento,
              largura: item.largura,
              altura: item.altura,
              peso: item.peso,
              valor_frete: item.valor_frete,
              embalagem: item.embalagem,
              id_tabela_preco: item.tabela_preco_itens && item.tabela_preco_itens.length > 0 ? item.tabela_preco_itens[0].tabela_preco.id : null,
              id_categoria: item.categoria !== null ? item.categoria.id : null,
              item_descricao: item.item_descricao,
              preco_venda: item.tabela_preco_itens.length > 0 ? item.tabela_preco_itens[0].preco_venda : '',
              ativo: item.ativo,
              imagens: item.imagens.map(img => ({ ...img, base64: null })),
              id_table_preco_item: item.tabela_preco_itens.length > 0 ? item.tabela_preco_itens[0].id : null,
            }
            store.commit('appAdmProdutos/SET_ITEM_DATA', itemData.value)
          })
          .catch(e => {
            console.log(e)
            toast({
              component: ToastificationContent,
              props: {
                title: 'Error',
                text: e.response.data.message || 'Error ao buscar produto',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
            resetClienteData()
          })
      }
      if (typeof router.currentRoute.params.id === 'undefined') {
        store.dispatch('appAdmProdutos/clearItemData')
      }
    })

    return {
      itemData,
      handleSubmit,
      resetClienteData,
    }
  },
}
</script>

<style>

</style>
